module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('h1', {
    staticClass: "headB"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/pre.htm"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REFACE")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/int.htm"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm"
    }
  }, [_vm._v("I. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HENOMENA")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NVESTIGATED")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm"
    }
  }, [_vm._v("II. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EGINNINGS OF")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RGANIZED")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESEARCH")]), _vm._v(": T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TORY OF THE")]), _vm._v(" S.P.R.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c03.htm"
    }
  }, [_vm._v("III. ‘A F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IT")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBJECT OF")]), _vm._v(" U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NIVERSITY")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TUDY AND")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESEARCH")]), _vm._v("’")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c04.htm"
    }
  }, [_vm._v("IV. F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFTY")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EARS OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HYSICAL")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HENOMENA")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c05.htm"
    }
  }, [_vm._v("V. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CHNEIDER")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OYS")]), _vm._v("—S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEET")]), _vm._v("-A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCHOR OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SYCHICAL")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESEARCH")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c06.htm"
    }
  }, [_vm._v("VI. ‘M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARGERY")]), _vm._v("’: "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SYCHIC")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IDDLE OF THE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WENTIETH")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENTURY")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c07.htm"
    }
  }, [_vm._v("VII. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TELLA")]), _vm._v(" C.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c08.htm"
    }
  }, [_vm._v("VIII. ‘R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSALIE")]), _vm._v("’")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c09.htm"
    }
  }, [_vm._v("IX. M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRACLES OF THE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IND")]), _vm._v(": S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OME")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMOUS")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENTAL")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EDIUMS")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c10.htm"
    }
  }, [_vm._v("X. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TORY OF")]), _vm._v(" E.S.P.")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c11.htm"
    }
  }, [_vm._v("XI. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECHANICS OF")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRITUALISM")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c12.htm"
    }
  }, [_vm._v("XII. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AW AND THE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EDIUM")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm"
    }
  }, [_vm._v("XIII. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CIENTIFIC")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETHOD IN")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SYCHICAL")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESEARCH")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c14.htm"
    }
  }, [_vm._v("XIV. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CIENCE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLVES THE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRE")]), _vm._v("-W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALK")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YSTERY")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c15.htm"
    }
  }, [_vm._v("XV. B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROADCASTING THE")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CCULT")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c16.htm"
    }
  }, [_vm._v("XVI. B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKS THAT HAVE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ADE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISTORY")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c17.htm"
    }
  }, [_vm._v("XVII. ‘I B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELIEVE")]), _vm._v(" …’")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/app1.htm"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPENDIX")]), _vm._v(" A.—T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EN")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HO")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ADE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SYCHICAL")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESEARCH")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/app2.htm"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPENDIX")]), _vm._v(" B.—T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRST")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SYCHIC")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABORATORY")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/app3.htm"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPENDIX")]), _vm._v(" C.—T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EXT OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROPOSED")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILL FOR THE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EGULATION OF")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SYCHIC AND")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CCULT")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RACTICES")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/fnt.htm"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOTNOTES")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/cop.htm"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPYRIGHT")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35487621","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 66
// module chunks = 0